var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTomujinAcademy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 157.67 35.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#632f8e;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 44.28,
    y1: 24.56,
    x2: 5.82,
    y2: -5.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#652c8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcd07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 33.96,
    y1: 37.66,
    x2: -4.51,
    y2: 7.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 33.22,
    y1: 38.59,
    x2: -5.25,
    y2: 8.26,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48,24.77h1.15l5,11H52.78L51.5,32.88H45.56l-1.3,2.89H43Zm3,7-2.48-5.57L46,31.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.61,30.34v0a5.5,5.5,0,0,1,5.52-5.65,5.68,5.68,0,0,1,4.26,1.73l-.84.91a4.73,4.73,0,0,0-3.44-1.5,4.28,4.28,0,0,0-4.22,4.48v0a4.3,4.3,0,0,0,4.22,4.51,4.74,4.74,0,0,0,3.53-1.58l.81.8A5.69,5.69,0,0,1,66.08,36,5.44,5.44,0,0,1,60.61,30.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.11,24.77h1.16l5,11H86.92l-1.28-2.89h-6L78.4,35.77H77.13Zm3,7-2.49-5.57-2.49,5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.87,24.85h3.79c3.43,0,5.8,2.35,5.8,5.43v0a5.47,5.47,0,0,1-5.8,5.46H95.87Zm3.79,9.78a4.22,4.22,0,0,0,4.52-4.29v0A4.25,4.25,0,0,0,99.66,26H97.1v8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.53,24.85h7.9V26h-6.66V29.7h6v1.13h-6v3.82h6.74v1.12h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.46,24.85h1.24l4,6,4-6h1.25V35.77h-1.23V26.92l-4,5.86h-.06l-4-5.84v8.83h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.88,31.45l-4.54-6.6h1.5l3.68,5.46,3.72-5.46h1.43l-4.54,6.58v4.34h-1.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43 0.38 57.16 0.38 57.16 3.98 51.96 3.98 51.96 19.26 48.17 19.26 48.17 3.98 43 3.98 43 0.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "80.63 0.38 80.63 19.26 84.22 19.26 84.22 5.91 90.06 15.99 95.87 5.92 95.87 19.26 99.46 19.26 99.46 0.38 94.92 0.38 90.05 8.83 85.18 0.38 80.63 0.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.38.38h-3.61V11.65A4.37,4.37,0,0,1,111.42,16h-.76a4.37,4.37,0,0,1-4.36-4.37V.38h-3.6V12.06a7.58,7.58,0,0,0,7.58,7.58h1.5a7.58,7.58,0,0,0,7.59-7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.87.38h-3.6v13a2.66,2.66,0,0,1-4.69,1.71l-2.94,2.46a5.69,5.69,0,0,0,4.4,2.09h1.14A5.69,5.69,0,0,0,131.87,14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.12,
    y: 0.38,
    width: 3.6,
    height: 18.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "141.95 0.38 141.95 19.26 145.56 19.26 145.56 6.05 153.19 19.26 157.68 19.26 157.68 0.38 154.07 0.38 154.07 13.6 146.44 0.38 141.95 0.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.66,0H66.83a9.11,9.11,0,0,0-9.11,9.11v1.43a9.1,9.1,0,0,0,9.11,9.1h1.83a9.1,9.1,0,0,0,9.11-9.1V9.11A9.11,9.11,0,0,0,68.66,0Zm-.92,16.19A6.36,6.36,0,1,1,74.1,9.83,6.36,6.36,0,0,1,67.74,16.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.96 0 35.92 35.92 35.92 0 17.96 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 0 0 35.92 17.96 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2.51 35.92 33.37 35.92 17.96 5.02 2.51 35.92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomujinAcademy);
export default __webpack_public_path__ + "static/media/tomujin_academy.b9f69e6716e92d246d2b7183a7816610.svg";
export { ForwardRef as ReactComponent };